  window.addEventListener('DOMContentLoaded', function () {
    const slidesCount = document.querySelectorAll('.swiper-slide').length;
    const enableLoop = slidesCount > 5;

    const swiper = new Swiper('.category-swiper', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 20,
      loop: enableLoop,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          centeredSlides: true,
        },
        640: {
          slidesPerView: 'auto',
          centeredSlides: true,
        },
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 5,
          centeredSlides: false,
        }
      }
    });

    // Disable autoplay on desktop
    if (window.innerWidth >= 768) {
      swiper.autoplay.stop();
    }

    // Hide arrows if 5 or fewer slides
    if (!enableLoop) {
      document.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach(el => {
        el.style.display = 'none';
      });
    }

    // IMAGE LOADING + SKELETON CONTROL
    const swiperElement = document.querySelector('.category-swiper');
    const skeleton = document.querySelector('.category-skeleton-loader');
    const images = swiperElement.querySelectorAll('img');
    let loadedImages = 0;

    if (images.length === 0) {
      // No images: Hide skeleton and show swiper immediately
      skeleton.style.display = 'none';
      swiperElement.style.display = 'block';
     } else {
      images.forEach((img) => {
        if (img.complete) {
          loadedImages++;
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === images.length) {
              skeleton.style.display = 'none';
              swiperElement.style.display = 'block';
              swiper.update(); // Important: Update swiper after showing
            }
          });
        }
      });

      // In case all images were already loaded
      if (loadedImages === images.length) {
        skeleton.style.display = 'none';
        swiperElement.style.display = 'block';
        swiper.update();
      }
    }
  });
